import { ConversationStep, Theme } from "../interfaces";
import { getReadableDate } from "../util";

import AppointmentAPICall from "../components/custom/AppointmentAPICall";
import AppointmentCalendar from "../components/custom/AppointmentCalendar";
import AppointmentTelephoneCall from "../components/custom/AppointmentTelephoneCall";
import SendNewLead from "../components/custom/SendNewLead";

const TriggerRedirection = (
  values: any,
  ifTrigger: string,
  elseTrigger: string,
  theme: Theme
) => {
  if (
    //@ts-ignore
    theme.products?.length > 0
  ) {
    return ifTrigger;
  }

  return elseTrigger;
};

const OfferingTrigger = (values: any, theme: Theme) =>
  TriggerRedirection(values, "product_item", "select_date", theme);

const AppointmentSteps = (theme: Theme) => {
  return [
    {
      id: "time_requested",
      message: "Which of the following would you prefer?",
      type: "bot",
      options: (values) => {
        const appointmentDate = new Date(
          values?.appointment_date.split("T")[0]
        );
        appointmentDate.setHours(0, 0, 0, 0);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const isToday = appointmentDate.getTime() === currentDate.getTime();
        const ukTime = new Date()
          .toLocaleTimeString("en-GB", {
            timeZone: "Europe/London",
          })
          .split(":");
        const hour = ukTime[0];
        const morning = {
          label: "Morning (9am - 12pm)",
          value: "Morning (9am - 12pm)",
          trigger: "contact_requested",
        };
        const lunch = {
          label: "Lunchtime (12pm - 3pm)",
          value: "Lunchtime (12pm - 3pm)",
          trigger: "contact_requested",
        };
        const afternoon = {
          label: "Afternoon (3pm - 6pm)",
          value: "Afternoon (3pm - 6pm)",
          trigger: "contact_requested",
        };

        const options = [];
        if (isToday) {
          if (parseInt(hour) < 12) {
            options.push(morning);
          }

          if (parseInt(hour) < 15) {
            options.push(lunch);
          }

          if (parseInt(hour) < 18) {
            options.push(afternoon);
          }

          return options;
        }

        return [morning, lunch, afternoon];
      },
    },
    {
      id: "talk_with_property_experts",
      message: "Would you like to talk to one of our Property Experts?",
      type: "bot",
      options: [
        {
          label: "Yes",
          value: "Yes",
          trigger: "select_date",
        },
        {
          label: "No",
          value: "No",
          trigger: "trigger_no_advisor",
        },
      ],
    },
    {
      id: "talk_with_advisor",
      message:
        theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341" ||
        theme?.apiKey === "546d6807-a0f0-45ef-8bf9-adfc7077b187"
          ? "As these options are an estimate based on the information given, and rates change quickly, our client services team will be in touch shortly to book you in for a free telephone appointment with one of our advisers who can discuss additional, more tailored options to suit your circumstances."
          : "Would you like to talk to one of our advisers?",
      type: "bot",
      disable(values) {
        return (
          (values?.theme?.apiKey === "6fda33d3-466e-4f97-b80b-9e55f7a7d1f2" &&
            (values["How can I help?"] === "Surveys" ||
              values["How can I help?"] === "Building & Contents")) ||
          (values?.theme?.apiKey === "6fda33d3-466e-4f97-b80b-9e55f7a7d1f2" &&
            values["How can I help?"] === "Insurance")
        );
      },
      options: [
        {
          label: "Yes",
          value: "Yes",
          trigger: (values) =>
            theme?.apiKey === "911997a2-825f-479c-ac80-b8a15a5f7e36"
              ? "preferred_date"
              : theme.apiKey === "43e63eb7-f1d4-4db0-a74b-1ec0c9096479"
              ? OfferingTrigger(values, theme)
              : "select_date",
        },
        {
          label: "No",
          value: "No",
          trigger: "can_i_help_with_anything_else",
        },
      ],
      trigger: (values: any) => {
        if (
          values?.theme?.apiKey === "6fda33d3-466e-4f97-b80b-9e55f7a7d1f2" &&
          values["How can I help?"] === "Insurance"
        ) {
          return "loading_insurance";
        }

        return "select_date";
      },
    },
    {
      id: "select_date",
      message:
        theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341" ||
        theme?.apiKey === "546d6807-a0f0-45ef-8bf9-adfc7077b187"
          ? "Please select your preferred date and time for the appointment you would like to schedule and we will contact you to confirm"
          : "Please select the date and time for the appointment you want to schedule",
      type: "bot",
      trigger: "appointment_date",
    },
    {
      id: "date_chosen",
      message: "You want to book on {previousValue}",
      type: "bot",
      trigger: "contact_requested",
      formatter: getReadableDate,
    },
    {
      id: "date_chosen_no_problem",
      message: "No problem.",
      type: "bot",
      trigger: "contact_requested",
    },
    {
      id: "contact_requested",
      message:
        theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341" ||
        theme?.apiKey === "546d6807-a0f0-45ef-8bf9-adfc7077b187"
          ? "What is your preferred appointment type?"
          : "How would you prefer to be contacted?",
      type: "bot",
      options: [
        {
          label: "Telephone Call",
          value: "Telephone Call",
          trigger: (values) => {
            //TODO: FOR HOMEFINDER FLOW

            if (
              values?.theme?.apiKey ===
                "546d6807-a0f0-45ef-8bf9-adfc7077b187" &&
              values?.theme?.version === "booking"
            ) {
              return "applicant1_firstName";
            }

            if (
              values?.theme?.apiKey === "911997a2-825f-479c-ac80-b8a15a5f7e36"
            ) {
              return "blank_send";
            }

            return "appointment_api";
          },
          enable: (values: any) =>
            !values.theme?.appointmentCustomization?.disableTelephoneCall,
        },
        {
          label: "Video Call",
          value: "Video Call",
          trigger: (values) => {
            //TODO: FOR HOMEFINDER FLOW

            if (
              values?.theme?.apiKey ===
                "546d6807-a0f0-45ef-8bf9-adfc7077b187" &&
              values?.theme?.version === "booking"
            ) {
              return "applicant1_firstName";
            }

            if (
              values?.theme?.apiKey === "911997a2-825f-479c-ac80-b8a15a5f7e36"
            ) {
              return "blank_send";
            }

            return "appointment_api";
          },
          enable: (values: any) =>
            values.theme.apiKey !== "d8eccbf3-bfa9-435b-9735-c91641c5446e" &&
            !values.theme?.appointmentCustomization?.disableVideoCall,
        },
        {
          label: "Face to Face Meeting",
          value: "Face to Face Meeting",
          trigger: (values) => {
            //TODO: FOR HOMEFINDER FLOW

            if (
              values?.theme?.apiKey ===
                "546d6807-a0f0-45ef-8bf9-adfc7077b187" &&
              values?.theme?.version === "booking"
            ) {
              return "applicant1_firstName";
            }

            if (
              values?.theme?.apiKey === "911997a2-825f-479c-ac80-b8a15a5f7e36"
            ) {
              return "blank_send";
            }

            return "appointment_api";
          },
          enable: (values: any) =>
            values.theme.apiKey !== "d8eccbf3-bfa9-435b-9735-c91641c5446e" &&
            !values.theme?.appointmentCustomization?.disableFaceToFaceMeeting,
        },
      ],
    },
    {
      id: "appointment_date",
      message:
        "Please select the date and time for the appointment you want to schedule",
      trigger: (values: any) => {
        if (values?.contact_requested === "Talk Now") {
          return "talk_now";
        }

        if (
          values?.theme?.appointmentCustomization?.disableAppointmentTime &&
          values?.theme?.apiKey === "24397e75-2096-4572-8e54-0cd37856e5b6"
        ) {
          return "contact_requested";
        }

        if (values?.theme?.appointmentCustomization?.disableAppointmentTime) {
          return "time_requested";
        }

        if (values?.theme?.version === "rightmove") {
          return "appointment_api";
        }

        return "contact_requested";
      },
      //date_chosen_no_problem
      component: <AppointmentCalendar />,
      type: "bot",
    },
    {
      id: "appointment_api",
      trigger: (values: any) => {
        if (values?.talk_with_advisor === "No") {
          return "trigger_no_advisor";
        }

        if (values?.contact_requested === "Talk Now") return "end_greeting";

        return "flow_end";
      },
      component: <AppointmentAPICall />,
      type: "bot",
    },
    {
      id: "trigger_no_advisor",
      type: "bot",
      component: <SendNewLead />,
      trigger: (values: any) => {
        if (
          values?.talk_with_advisor === "No" &&
          values?.theme?.apiKey === "d6176c89-bca5-4454-9101-20f15203dc87"
        ) {
          return "trigger_no_advisor_end2";
        }

        if (values?.theme?.apiKey === "b530f92d-4151-4bfc-9691-879b4011d67f") {
          return "team_end_text";
        }

        if (values?.theme?.apiKey === "31866677-e315-4465-bbe2-07582d725823") {
          return "";
        }

        return "trigger_no_advisor_end";
      },
    },
    {
      id: "select_date_sendnewlead",
      type: "bot",
      component: <SendNewLead />,
      trigger: "select_date",
    },
    {
      id: "loading_illustration_sendnewlead",
      type: "bot",
      component: <SendNewLead />,
      trigger: "loading_illustration",
    },
    {
      id: "insurance_quote_sendnewlead",
      type: "bot",
      component: <SendNewLead />,
      trigger: "insurance_quote",
    },
    {
      id: "trigger_no_advisor_end",
      type: "bot",
      message:
        "We highly recommend seeking good quality advice when it comes to your financial needs",
      trigger: (values: any) => {
        return "trigger_no_advisor_end1";
      },
    },
    {
      id: "trigger_no_advisor_end1",
      type: "bot",
      message: `Please feel free to adjust your search parameters above, or contact us directly at ${theme?.email}.`,
      trigger: "trigger_no_advisor_end2",
    },
    {
      id: "trigger_no_advisor_end2",
      type: "bot",
      message: "Have a lovely day",
      end: true,
    },
    {
      id: "talk_now",
      type: "bot",
      component: <AppointmentTelephoneCall />,
      trigger: () => {
        return "appointment_api";
      },
    },

    //CLIENT SPECIFIC
    {
      id: "preferred_date",
      type: "bot",
      message:
        "Please identify a preferred time and date to talk to an advisor?",
      input: {
        type: "text",
      },
      trigger: "contact_requested",
    },
  ] as ConversationStep[];
};

export default AppointmentSteps;
